const ORIGIN = (process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000').replace(/\/$/, '');
export const DOMAIN_BASE = ORIGIN;
export const API_BASE = `${ORIGIN}/api`;

export const DOMAIN_MEDIA = `${DOMAIN_BASE}/media/`;
